import { useInfiniteQuery } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { QUERY_KEYS, HTTP_ENDPOINTS } from "../../../../../../consts/api";
import { getNextPaginationPage } from "../../../../../../schemas/pagination";

export const useMembershipFeesDetail = (params, options = {}) => {
  return useInfiniteQuery({
    queryKey: [QUERY_KEYS.membershipFeesDetail, params],
    queryFn: async ({ pageParam = 1 }) => {
      try {
        const res = await http.get(HTTP_ENDPOINTS.getMembershipFeesDetail(), {
          params: {
            ...params,
            limit: 20,
            page: pageParam,
          },
        });

        const reportData = res.data.data.data || [];
        const apiPagination = res.data.data.pagination || {};

        // Determine hasNextPage by comparing current_page with last_page from apiPagination
        const hasNextPage =
          apiPagination.current_page < apiPagination.last_page;

        const paginationInfo = {
          currentPage: apiPagination.current_page || pageParam,
          total: apiPagination.total || 0,
          totalPages: apiPagination.last_page || 0,
          hasNextPage: hasNextPage,
          nextPage: hasNextPage ? pageParam + 1 : undefined,
        };

        const composeResponse = {
          ...paginationInfo,
          report: reportData,
          clinics: res.data.data.clinics || [],
          summary: res.data.data.summary || {},
        };

        return composeResponse;
      } catch (error) {
        throw error;
      }
    },
    ...options,
    getNextPageParam: getNextPaginationPage,
    retry: false, // Don't retry failed requests for now
  });
};
